import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { T } from 'shared/helper/translate';
var DigitalTranslationsHeader = function DigitalTranslationsHeader(_ref) {
  var busy = _ref.busy,
    numberOfUsesAvailable = _ref.numberOfUsesAvailable;
  return /*#__PURE__*/React.createElement("div", {
    className: "row digital-translations-header"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-12"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "pb-0 mb-2"
  }, /*#__PURE__*/React.createElement(T, {
    source: "digital-translations"
  }), /*#__PURE__*/React.createElement("span", {
    className: "ms-2 badge ".concat(numberOfUsesAvailable === 0 ? 'bg-warning' : 'bg-success', " rounded text-white text-small align-middle")
  }, /*#__PURE__*/React.createElement(T, {
    source: "you-have-x-digital-translation-uses-available",
    params: numberOfUsesAvailable
  })), busy ? /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    className: "ms-2 text-muted",
    icon: "fa-solid fa-spinner-scale",
    spin: true
  }) : null)));
};
export default DigitalTranslationsHeader;